import WorkOrderExecutionControlTime from '@/models/WorkOrderExecution/WorkOrderExecutionControlTime';

export default class WorkOrderExecutionControlTimeFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderExecutionId  = '';
		this.workOrderExecutionShift = '';
		this.productionControlTimeId  = '';
		this.productionControlTimeStandarTimeId = '';
		this.startControlTimeFrom = '';
		this.startControlTimeTo = '';
		this.stopControlTimeFrom = '';
		this.stopControlTimeTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderExecutionId : '0',
			workOrderExecutionShift : '0',
			productionControlTimeId : '0',
			productionControlTimeStandarTimeId : '0',
			startControlTimeFrom : '0',
			startControlTimeTo : '0',
			stopControlTimeFrom : '0',
			stopControlTimeTo : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}